import axios from "axios";
import React, { useEffect, useState } from "react";
import { useRouteMatch } from "react-router-dom/cjs/react-router-dom.min";
import { Button, ButtonGroup, Col, Form, Row } from "react-bootstrap";
import { FaPen, FaSave, FaTrash } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import SelectIndiretoModal from "./SelectIndiretoModal";

const IndiretoDetailModal = ({ currentTab, item, edit, onCancel, dadosPlanejamento, setDadosPlanejamento, allCustosIndiretos }) => {

    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [showSelectModal, setShowSelectModal] = useState(false);
    const match = useRouteMatch();
    const { key } = match.params;
    const [cotacoes, setCotacoes] = useState({
        BRL: "1.00",
        USD: "0.00",
        EUR: "0.00"
    })

    // Função para formatação de valores digitados pelo usuário (mantém experiência original)
    const mask = (value) => {
        value = value.replaceAll('.', '').replace(',', '').replace(/\D/g, '')
        const options = { minimumFractionDigits: 2 }
        const result = new Intl.NumberFormat('pt-BR', options).format(
            parseFloat(value) / 100
        )
        return result
    }

    // Função auxiliar para converter valores do banco para formato brasileiro
    const formatBankValueToBR = (value) => {
        if (!value && value !== 0) return "0,00";
        
        const strValue = value.toString();
        
        // Se contém ponto (formato americano do banco), converte para brasileiro
        if (strValue.includes('.') && !strValue.includes(',')) {
            const numValue = parseFloat(strValue);
            if (isNaN(numValue)) return "0,00";
            
            const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 }
            return new Intl.NumberFormat('pt-BR', options).format(numValue);
        }
        
        // Se já está no formato brasileiro, retorna como está
        return strValue;
    }

    const convertCotacoes = (value, cotacao) => {
        const valueFormated = parseFloat(value.replaceAll('.', '').replace(',', '.'));
        const cotacaoFormated = parseFloat(cotacao.replace(',', '.'));
        const result = (valueFormated * cotacaoFormated).toFixed(2);

        // Formatar o resultado para o padrão brasileiro
        const options = { minimumFractionDigits: 2 }
        return new Intl.NumberFormat('pt-BR', options).format(parseFloat(result));
    }

    const getCotacoes = async () => {
        try {
            const config = {
                method: 'get',
                url: `https://economia.awesomeapi.com.br/last/USD-BRL,EUR-BRL`
            };

            const result = await axios(config);
            setCotacoes({
                BRL: "1,00",
                USD: formatBankValueToBR(parseFloat(result.data['USDBRL'].bid).toFixed(2)),
                EUR: formatBankValueToBR(parseFloat(result.data['EURBRL'].bid).toFixed(2))
            })
        } catch (error) {
            console.error("Erro ao buscar cotações:", error);
        }
    }

    const onChangeData = (event) => {
        const { name, value } = event.target;
        switch (name) {
            case "tipoCusto":
                setFormData({ ...formData, [name]: value });
                break;
            case "descricao":
                setFormData({ ...formData, [name]: value.toUpperCase() });
                break;
            case "valor":
                setFormData({ ...formData, [name]: mask(value) });
                break;
            case "moeda":
                const convertedValue = convertCotacoes(formData.valorOriginal, cotacoes[value]);
                setFormData({ ...formData, [name]: value, cotacao: cotacoes[value], valor: convertedValue });
                break;
            case "cotacao":
                const convertedValueCotacao = convertCotacoes(formData.valorOriginal, mask(value));
                setFormData({ ...formData, [name]: mask(value), valor: convertedValueCotacao });
                break;
            case "valorOriginal":
                const convertedValueOriginal = convertCotacoes(mask(value), formData.cotacao);
                setFormData({ ...formData, [name]: mask(value), valor: convertedValueOriginal });
                break;
            case "observacao":
                setFormData({ ...formData, [name]: value });
                break;
            default:
                break;
        }

        setErrors({})
    }

    const handleIndireto = (data) => {
        if (item) {
            const valorOriginal = data.valorOriginal;
            const valor = convertCotacoes(valorOriginal, data.cotacao);

            const valorOriginalFloat = parseFloat(valorOriginal.replaceAll('.', '').replace(',', '.'));
            const novoValorFloat = parseFloat(valor.replaceAll('.', '').replace(',', '.'));

            const valorAntigo = parseFloat(item.valor_custo_indireto);
            const valorTotalIndiretoAtual = parseFloat(dadosPlanejamento.meses[currentTab].total_previsto_indireto || 0);
            const itemAtualizado = {
                descricao_custo_indireto: data.descricao,
                moeda: data.moeda,
                cotacao: data.cotacao.replaceAll('.', '').replace(',', '.'),
                valor_custo_indireto: novoValorFloat.toFixed(2),
                valor_original_custo_indireto: valorOriginalFloat.toFixed(2),
                tipo: data.tipoCusto,
                observacao: data.observacao
            }

            const dadosPlanejamentoAtualizado = {
                ...dadosPlanejamento,
                meses: {
                    ...dadosPlanejamento.meses,
                    [currentTab]: {
                        ...dadosPlanejamento.meses[currentTab],
                        previstoIndireto: dadosPlanejamento.meses[currentTab].previstoIndireto.map(func => {
                            if (func.id && item.id) {
                                return func.id === item.id ? {
                                    ...func,
                                    ...itemAtualizado
                                } : func;
                            }
                            if (!func.id && !item.id) {
                                return func.tempId === item.tempId ? {
                                    ...func,
                                    ...itemAtualizado
                                } : func;
                            }
                            return func;
                        }),
                        total_previsto_indireto: (valorTotalIndiretoAtual - valorAntigo + novoValorFloat).toFixed(2)
                    }
                }
            };
            setDadosPlanejamento(dadosPlanejamentoAtualizado);
        } else {
            setDadosPlanejamento((prevDadosPlanejamento) => {
                const novoCusto = data;
                const projeto = key;
                const mesAno = currentTab;

                let proximoIndice = 1;
                let proximoId = 3000;
                let proximoTempId = 1;

                Object.values(prevDadosPlanejamento.meses).forEach((mes) => {
                    mes.previstoIndireto.forEach((custo) => {
                        const idx = parseInt(custo.indice, 10);
                        const id = parseInt(custo.id, 10);
                        const tempId = parseInt(custo.tempId, 10);
                        if (idx >= proximoIndice) proximoIndice = idx + 1;
                        if (id >= proximoId) proximoId = id + 1;
                        if (tempId >= proximoTempId) proximoTempId = tempId + 1;
                    });
                });

                const novosMeses = { ...prevDadosPlanejamento.meses };
                const valor = parseFloat(novoCusto.valor.replaceAll(".", "").replace(",", "."));
                const valorOriginal = parseFloat(novoCusto.valorOriginal.replaceAll(".", "").replace(",", "."));
                const cotacao = parseFloat(novoCusto.cotacao.replaceAll(".", "").replace(",", "."));

                novosMeses[mesAno].previstoIndireto.push({
                    tempId: String(proximoTempId++),
                    indice: String(proximoIndice++),
                    descricao_custo_indireto: novoCusto.descricao,
                    valor_custo_indireto: valor.toFixed(2),
                    projeto,
                    mes_ano: mesAno,
                    tipo: novoCusto.tipoCusto,
                    valor_original_custo_indireto: valorOriginal.toFixed(2),
                    moeda: novoCusto.moeda,
                    cotacao: cotacao.toFixed(2),
                    observacao: novoCusto.observacao
                });

                novosMeses[mesAno].total_previsto_indireto = (parseFloat(novosMeses[mesAno].total_previsto_indireto) || 0) + valor;

                return {
                    ...prevDadosPlanejamento,
                    meses: novosMeses,
                };
            });
        }
        onCancel();
    }

    const handleDeleteIndireto = () => {
        const updatedDeletedIndireto = dadosPlanejamento.meses[currentTab].previstoIndireto.filter(custo => {
            if (item.id) {
                return custo.id !== item.id;
            } else {
                return custo.tempId !== item.tempId;
            }
        });

        setDadosPlanejamento((prevDadosPlanejamento) => {
            return {
                ...prevDadosPlanejamento,
                meses: {
                    ...prevDadosPlanejamento.meses,
                    [currentTab]: {
                        ...prevDadosPlanejamento.meses[currentTab],
                        previstoIndireto: updatedDeletedIndireto,
                        total_previsto_indireto: prevDadosPlanejamento.meses[currentTab].total_previsto_indireto - parseFloat(item.valor_custo_indireto)
                    }
                }
            };
        })
        onCancel();
    }

    const handleSave = () => {
        const newErrors = {};

        if (!formData.descricao?.trim()) {
            newErrors.descricao = "Campo obrigatório";
        }

        if (formData.tipoCusto?.trim() === "") {
            newErrors.tipoCusto = "Campo obrigatório";
        }

        const valor = formData.valorOriginal?.replace(",", ".").trim();
        const valorNumero = parseFloat(valor);

        if (!valor || isNaN(valorNumero) || valorNumero === 0) {
            newErrors.valorOriginal = "Campo obrigatório";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        handleIndireto(formData);
    };

    const handleSelectIndireto = (custo) => {
        setFormData({
            tipoCusto: custo.tipo,
            descricao: custo.descricao_custo_indireto,
            valor: formatBankValueToBR(custo.valor_custo_indireto),
            moeda: custo.moeda || "BRL",
            cotacao: formatBankValueToBR(custo.cotacao || "1.00"),
            valorOriginal: formatBankValueToBR(custo.valor_original_custo_indireto),
            observacao: custo.observacao
        });
        setShowSelectModal(false);
    };

    useEffect(() => {
        const formDataItem = item ? {
            tipoCusto: item?.tipo,
            descricao: item?.descricao_custo_indireto,
            valor: item?.valor_custo_indireto
                ? formatBankValueToBR(item.valor_custo_indireto)
                : "0,00",
            moeda: item?.moeda || "BRL",
            cotacao: item?.cotacao 
                ? formatBankValueToBR(item.cotacao)
                : "1,00",
            valorOriginal: item?.valor_original_custo_indireto
                ? formatBankValueToBR(item.valor_original_custo_indireto)
                : "0,00",
            observacao: item?.observacao || ""
        } : {
            tipoCusto: "",
            descricao: "",
            valor: "0,00",
            moeda: "BRL",
            cotacao: "1,00",
            valorOriginal: "0,00",
            observacao: ""
        }

        setFormData(formDataItem);
        getCotacoes();
    }, [item]);

    return (
        <Form>
            <Row className="mb-3">
                <Col>
                    <Form.Label>Tipo</Form.Label>
                    <Form.Control
                        as="select"
                        name="tipoCusto"
                        value={formData?.tipoCusto}
                        onChange={onChangeData}
                        disabled={!edit}
                        isInvalid={!!errors?.tipoCusto}
                    >
                        <option value="">Selecione</option>
                        <option value="INFRA_CLOUD">Infraestrutura em Cloud</option>
                        <option value="OUTROS_SOFTWARES">Outros softwares</option>
                        <option value="HORAS_EXTRAS">Horas extras</option>
                        <option value="FORNECEDORES_TERCEIROS">Fornecedores terceiros</option>
                        <option value="OUTROS">Outros</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                        {errors?.tipoCusto}
                    </Form.Control.Feedback>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Form.Label>Descrição</Form.Label>
                    <Form.Control
                        type="text"
                        name="descricao"
                        value={formData?.descricao}
                        onChange={onChangeData}
                        disabled={!edit}
                        isInvalid={!!errors?.descricao}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.descricao}
                    </Form.Control.Feedback>
                </Col>
                <Col>
                    <Form.Label>Valor Original</Form.Label>
                    <Form.Control
                        type="text"
                        name="valorOriginal"
                        value={formData?.valorOriginal}
                        onChange={onChangeData}
                        disabled={!edit}
                        isInvalid={!!errors?.valorOriginal}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.valorOriginal}
                    </Form.Control.Feedback>
                </Col>
            </Row>

            <Row className="mt-3">
                <Col>
                    <Form.Label>Moeda</Form.Label>
                    <Form.Control
                        as="select"
                        name="moeda"
                        value={formData?.moeda}
                        onChange={onChangeData}
                        disabled={!edit}
                    >
                        <option value="BRL">Real</option>
                        <option value="USD">Dólar</option>
                        <option value="EUR">Euro</option>
                    </Form.Control>
                </Col>
                {formData.moeda !== 'BRL' && (
                    <Col>
                        <Form.Label>Cotação</Form.Label>
                        <Form.Control
                            type="text"
                            name="cotacao"
                            autoComplete='off'
                            maxLength={5}
                            value={formData?.cotacao}
                            onChange={onChangeData}
                            disabled={!edit}
                        />
                    </Col>
                )}
            </Row>
            <Row className="mt-3">
                <Col>
                    <Form.Label>Valor Convertido (BRL)</Form.Label>
                    <Form.Control
                        type="text"
                        value={formData?.valor}
                        disabled={true}
                    />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    <Form.Label>Observações</Form.Label>
                    <Form.Control
                        as="textarea"
                         name="observacao"
                        value={formData?.observacao}
                        onChange={onChangeData}
                        disabled={!edit}
                        isInvalid={!!errors?.observacao}
                        maxLength={200}
                    />
                    <Form.Text muted className="text-end d-block">
                        {formData.observacao?.length || 0}/200
                    </Form.Text>
                </Col>
            </Row>
            {edit &&
                <div className={`mt-3 d-flex justify-content-${item ? "end" : "between"}`}>
                    {!item && <Button 
                        variant="outline-info" 
                        style={{ marginRight: "10px", cursor: allCustosIndiretos.length === 0 ? "not-allowed" : "pointer" }} 
                        disabled={allCustosIndiretos.length === 0} 
                        onClick={() => setShowSelectModal(true)}
                    >
                        Adicionar um de outro mês
                    </Button>}
                    <ButtonGroup>
                        <Button
                            variant={"outline-info"}
                            onClick={handleSave}
                            disabled={!edit}
                        >
                           <><FaPen /> Confirmar</>
                        </Button>
                        <Button
                            variant="outline-danger"
                            onClick={item ? () => handleDeleteIndireto(item) : onCancel}
                            disabled={!edit}
                        >
                            {item ? <><FaTrash /> Excluir</> : <><MdClose /> Cancelar</>}
                        </Button>
                    </ButtonGroup>
                </div>}
            
            <SelectIndiretoModal
                show={showSelectModal}
                onHide={() => setShowSelectModal(false)}
                custosIndiretos={allCustosIndiretos}
                onSelect={handleSelectIndireto}
            />
        </Form>
    );
};

export default IndiretoDetailModal;